var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.267 25.832A3.086 3.086 0 0120.272 32h-9.186a3.086 3.086 0 01-.005-6.168h9.186zM20.525.08c.731-.267 1.52.168 1.763.973l1.461 4.848c.221.731.296 1.507.224 2.272l-1.2 12.605c-.187 1.963-1.685 3.451-3.469 3.453h-9.211c-.773 0-1.397-.693-1.397-1.547v-1.539c0-.853.624-1.544 1.397-1.544h7.325c.715-.003 1.312-.6 1.387-1.387l1-10.533-.032-.323-1.459-4.845c-.24-.811.155-1.68.888-1.949z"
  })));
}
export default SvgSeat;